module.exports = __webpack_public_path__ + "img/she_killed_in_ecstasy_soledad_desk.6a63f104.jpg";